import { lazy } from 'react'
import { Props as EBTFooterProps } from '@components/ebt-footer'
import { Props as PRVFooterProps } from '@components/prv-footer'
import { Props as VPFooterProps } from '@components/vp-footer'
import { Config, GetPartnerConfig } from './types'

// eslint-disable-next-line @typescript-eslint/promise-function-async
const EBTFooter = lazy(() => import(/* webpackChunkName: "EBTFooter" */ '@components/ebt-footer'))
// eslint-disable-next-line @typescript-eslint/promise-function-async
const PRVFooter = lazy(() => import(/* webpackChunkName: "PRVFooter" */ '@components/prv-footer'))
// eslint-disable-next-line @typescript-eslint/promise-function-async
const VPFooter = lazy(() => import(/* webpackChunkName: "VPFooter" */ '@components/vp-footer'))

export const getPartnerConfig: GetPartnerConfig = (
  countryCode,
  cultureCode,
  partner,
  screenSize
) => {
  const config: Config = ({
    EBT: {
      component: EBTFooter,
      props: {
        cultureCode: cultureCode as EBTFooterProps['cultureCode'],
        isLarge: screenSize.large
      }
    },
    PRV: {
      component: PRVFooter,
      props: {
        countryCode: countryCode as PRVFooterProps['countryCode'],
        cultureCode: cultureCode as PRVFooterProps['cultureCode'],
        isLarge: screenSize.large
      }
    },
    VEX: {
      component: VPFooter,
      props: {
        countryCode: countryCode as VPFooterProps['countryCode'],
        cultureCode: cultureCode as VPFooterProps['cultureCode'],
        isLarge: screenSize.large
      }
    },
    VP: {
      component: VPFooter,
      props: {
        countryCode: countryCode as VPFooterProps['countryCode'],
        cultureCode: cultureCode as VPFooterProps['cultureCode'],
        isLarge: screenSize.large
      }
    }
  })
  return config[partner]
}
